/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  AiScanTargetGatewayClient,
  AiScanTargetGatewayClient$Outbound,
  AiScanTargetGatewayClient$outboundSchema,
} from "./aiscantargetgatewayclient.js";
import {
  AiScanTargetSignatures,
  AiScanTargetSignatures$Outbound,
  AiScanTargetSignatures$outboundSchema,
} from "./aiscantargetsignatures.js";

/**
 * Target category: harness (an AI coding tool), assistant (a general-purpose AI assistant or agent), or local_model (an open model run locally).
 */
export const UpsertAiScanTargetRequestBodyCategory = {
  Harness: "harness",
  Assistant: "assistant",
  LocalModel: "local_model",
} as const;
/**
 * Target category: harness (an AI coding tool), assistant (a general-purpose AI assistant or agent), or local_model (an open model run locally).
 */
export type UpsertAiScanTargetRequestBodyCategory = ClosedEnum<
  typeof UpsertAiScanTargetRequestBodyCategory
>;

export type UpsertAiScanTargetRequestBody = {
  /**
   * Target category: harness (an AI coding tool), assistant (a general-purpose AI assistant or agent), or local_model (an open model run locally).
   */
  category: UpsertAiScanTargetRequestBodyCategory;
  /**
   * Name shown in the dashboard.
   */
  displayName: string;
  /**
   * How a target detected on a device is recognized again when the same tool calls Speakeasy's MCP gateway. A device signature and a registered OAuth client share no natural join key, so the link is declared here. The three lists are not interchangeable: the first two name credentials Speakeasy verified and can be enforced on, the third names what a client said about itself and is used only to attribute traffic.
   */
  gatewayClient?: AiScanTargetGatewayClient | undefined;
  /**
   * Stable id agents report and detections key on. Never reused for a different tool.
   */
  id: string;
  /**
   * On-device signals the scan checks for one target.
   */
  signatures: AiScanTargetSignatures;
  /**
   * Info.plist key to read the installed version from on a bundle match; defaults to CFBundleShortVersionString when omitted.
   */
  versionPlistKey?: string | undefined;
};

/** @internal */
export const UpsertAiScanTargetRequestBodyCategory$outboundSchema:
  z.ZodMiniEnum<typeof UpsertAiScanTargetRequestBodyCategory> = z.enum(
    UpsertAiScanTargetRequestBodyCategory,
  );

/** @internal */
export type UpsertAiScanTargetRequestBody$Outbound = {
  category: string;
  display_name: string;
  gateway_client?: AiScanTargetGatewayClient$Outbound | undefined;
  id: string;
  signatures: AiScanTargetSignatures$Outbound;
  version_plist_key?: string | undefined;
};

/** @internal */
export const UpsertAiScanTargetRequestBody$outboundSchema: z.ZodMiniType<
  UpsertAiScanTargetRequestBody$Outbound,
  UpsertAiScanTargetRequestBody
> = z.pipe(
  z.object({
    category: UpsertAiScanTargetRequestBodyCategory$outboundSchema,
    displayName: z.string(),
    gatewayClient: z.optional(AiScanTargetGatewayClient$outboundSchema),
    id: z.string(),
    signatures: AiScanTargetSignatures$outboundSchema,
    versionPlistKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      displayName: "display_name",
      gatewayClient: "gateway_client",
      versionPlistKey: "version_plist_key",
    });
  }),
);

export function upsertAiScanTargetRequestBodyToJSON(
  upsertAiScanTargetRequestBody: UpsertAiScanTargetRequestBody,
): string {
  return JSON.stringify(
    UpsertAiScanTargetRequestBody$outboundSchema.parse(
      upsertAiScanTargetRequestBody,
    ),
  );
}
